import { Alert, Text } from '@libs/ui/ds'
import { GUIDE_URL } from '@libs/utils/environments'
import { useMemberLockTranslation } from '@libs/utils/translations'
import { routes } from '@spa/core/router'
import { useMemoSelector } from '@spa/redux/hooks'
import type { MomentInput } from 'moment'
import type { FC } from 'react'
import { Trans } from 'react-i18next'
import { Link } from 'react-router-dom'
import { getCurrentUser } from 'snap-redux/modules/users/selectors'

export const LOCKED_FIELDS_INFO = 'lockedFieldsInfo'
export const BLOCKED_DATES_INFO = 'blockedDatesInfo'
export const CONTRACT_TIME_INFO = 'contractTimeInfo'
export const MODULATION = 'modulation'

export const INFO_TYPES = {
  LOCKED_FIELDS_INFO: 'lockedFieldsInfo',
  BLOCKED_DATES_INFO: 'blockedDatesInfo',
  CONTRACT_TIME_INFO: 'contractTimeInfo',
  MODULATION: 'modulation'
}

type Types =
  | 'lockedFieldsInfo'
  | 'blockedDatesInfo'
  | 'contractTimeInfo'
  | 'modulation'

type Props = {
  type: Types
  payPeriodsStart?: MomentInput
  payPeriodsEnd?: MomentInput
}

const LockInformation: FC<Props> = ({
  type,
  payPeriodsStart,
  payPeriodsEnd
}) => {
  const { t, tCommon } = useMemberLockTranslation()
  const currentUser = useMemoSelector(getCurrentUser)
  const languageOfUser = currentUser?.locale.toLowerCase()

  const {
    LOCKED_FIELDS_INFO,
    BLOCKED_DATES_INFO,
    CONTRACT_TIME_INFO,
    MODULATION
  } = INFO_TYPES

  return (
    <Alert
      title={t('locked.period')}
      switchAt='all'
      endSection={
        <Alert.Button
          type='button'
          size='s'
          component='a'
          href={`${GUIDE_URL}${languageOfUser}/articles/1205688`}
          target='_blank'
          rel='noopener noreferrer'
        >
          {tCommon('action.see.more')}
        </Alert.Button>
      }
    >
      {type === LOCKED_FIELDS_INFO && (
        <>
          <Text>{t('locked.amendment')}</Text>
          <Text>
            <Trans
              t={t}
              i18nKey='locked.update'
              components={{
                transLink: <Link to={routes.reportsPayrollsList.rootPath} />
              }}
            />
          </Text>
        </>
      )}
      {type === BLOCKED_DATES_INFO && (
        <Text>
          {t('blockedDates', {
            start: payPeriodsStart,
            end: payPeriodsEnd
          })}
        </Text>
      )}
      {type === CONTRACT_TIME_INFO && <Text>{t('timeInfo')}</Text>}
      {type === MODULATION && <Text>{t('modulation')}</Text>}
    </Alert>
  )
}

export default LockInformation
